import React, { useState, useEffect } from 'react';
import 'tailwindcss/tailwind.css';
import { getAllCars } from '../utils/Api';
import { Link } from 'react-router-dom';

const Aanbod = () => {
  const [cars, setCars] = useState([]);
  const [filteredCars, setFilteredCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    merk: '',
    model: '',
    brandstof: [],
    transmissie: [],
    carrosserie: [],
    prijsMin: '',
    prijsMax: '',
    kmstandMin: '',
    kmstandMax: '',
    pkMin: '',
    pkMax: '',
    aantalDeurenMin: '',
    aantalDeurenMax: '',
    gewichtMin: '',
    gewichtMax: '',
    aantalZitplaatsenMin: '',
    aantalZitplaatsenMax: '',
    aantalCilindersMin: '',
    aantalCilindersMax: '',
    motorinhoudMin: '',
    motorinhoudMax: '',
    kleur: [],
    interieurkleur: [],
    bekledingsoort: [],
    aandrijving: [],
    bouwjaarMin: '',
    bouwjaarMax: '',
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await getAllCars();
        setCars(response.sort((a, b) => (a.verkocht === b.verkocht ? 0 : a.verkocht ? 1 : -1)));
        setFilteredCars(response);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchCars();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (category, value) => {
    setFilters(prev => ({
      ...prev,
      [category]: prev[category].includes(value)
        ? prev[category].filter(item => item !== value)
        : [...prev[category], value]
    }));
  };

  useEffect(() => {
    let result = cars;

    if (filters.merk) {
      result = result.filter(car => car.merk?.toLowerCase().includes(filters.merk.toLowerCase()));
    }
    if (filters.model) {
      result = result.filter(car => car.model?.toLowerCase().includes(filters.model.toLowerCase()));
    }
    if (filters.brandstof.length > 0) {
      result = result.filter(car => filters.brandstof.includes(car.brandstof));
    }
    if (filters.transmissie.length > 0) {
      result = result.filter(car => filters.transmissie.includes(car.transmissie));
    }
    if (filters.carrosserie.length > 0) {
      result = result.filter(car => filters.carrosserie.includes(car.carrosserie));
    }
    if (filters.prijsMin) {
      result = result.filter(car => car.prijs >= parseInt(filters.prijsMin));
    }
    if (filters.prijsMax) {
      result = result.filter(car => car.prijs <= parseInt(filters.prijsMax));
    }
    if (filters.kmstandMin) {
      result = result.filter(car => car.kmstand >= parseInt(filters.kmstandMin));
    }
    if (filters.kmstandMax) {
      result = result.filter(car => car.kmstand <= parseInt(filters.kmstandMax));
    }
    if (filters.pkMin) {
      result = result.filter(car => car.pk >= parseInt(filters.pkMin));
    }
    if (filters.pkMax) {
      result = result.filter(car => car.pk <= parseInt(filters.pkMax));
    }
    if (filters.aantalDeurenMin) {
      result = result.filter(car => car.aantalDeuren >= parseInt(filters.aantalDeurenMin));
    }
    if (filters.aantalDeurenMax) {
      result = result.filter(car => car.aantalDeuren <= parseInt(filters.aantalDeurenMax));
    }
    if (filters.gewichtMin) {
      result = result.filter(car => car.gewicht >= parseInt(filters.gewichtMin));
    }
    if (filters.gewichtMax) {
      result = result.filter(car => car.gewicht <= parseInt(filters.gewichtMax));
    }
    if (filters.aantalZitplaatsenMin) {
      result = result.filter(car => car.aantalZitplaatsen >= parseInt(filters.aantalZitplaatsenMin));
    }
    if (filters.aantalZitplaatsenMax) {
      result = result.filter(car => car.aantalZitplaatsen <= parseInt(filters.aantalZitplaatsenMax));
    }
    if (filters.aantalCilindersMin) {
      result = result.filter(car => car.aantalCilinders >= parseInt(filters.aantalCilindersMin));
    }
    if (filters.aantalCilindersMax) {
      result = result.filter(car => car.aantalCilinders <= parseInt(filters.aantalCilindersMax));
    }
    if (filters.motorinhoudMin) {
      result = result.filter(car => car.motorinhoud >= parseInt(filters.motorinhoudMin));
    }
    if (filters.motorinhoudMax) {
      result = result.filter(car => car.motorinhoud <= parseInt(filters.motorinhoudMax));
    }
    if (filters.kleur.length > 0) {
      result = result.filter(car => filters.kleur.includes(car.kleur));
    }
    if (filters.interieurkleur.length > 0) {
      result = result.filter(car => filters.interieurkleur.includes(car.interieurkleur));
    }
    if (filters.bekledingsoort.length > 0) {
      result = result.filter(car => filters.bekledingsoort.includes(car.bekledingsoort));
    }
    if (filters.aandrijving.length > 0) {
      result = result.filter(car => filters.aandrijving.includes(car.aandrijving));
    }
    if (filters.bouwjaarMin) {
      result = result.filter(car => {
        const jaar = parseInt(car.datum?.split('-')[0]);
        return jaar >= parseInt(filters.bouwjaarMin);
      });
    }
    if (filters.bouwjaarMax) {
      result = result.filter(car => {
        const jaar = parseInt(car.datum?.split('-')[0]);
        return jaar <= parseInt(filters.bouwjaarMax);
      });
    }

    setFilteredCars(result);
  }, [filters, cars]);

  const getDefaultImage = () => {
    return 'https://via.placeholder.com/400x300?text=Geen+Afbeelding';
  };

  const getCarImage = (car) => {
    if (car.imageLinks && car.imageLinks.length > 0) {
      const imageUrl = car.imageLinks[0].replace(/^\/+/, '');
      const apiUrl = 'https://s-backend-rebuild-production.up.railway.app';
      return `${apiUrl}/${imageUrl}`;
    }
    return getDefaultImage();
  };

  const getMerkOptions = () => {
    const merkCounts = cars.reduce((acc, car) => {
      if (car.merk) {
        acc[car.merk] = (acc[car.merk] || 0) + 1;
      }
      return acc;
    }, {});

    return Object.entries(merkCounts)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([merk, count]) => ({
        value: merk,
        label: `${merk} (${count})`
      }));
  };

  const getUniqueValues = (field) => {
    const values = cars.map(car => car[field]).filter(value => value);
    return [...new Set(values)].sort();
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto py-6 px-4">
          <h1 className="text-3xl font-bold text-gray-900">Ons Aanbod</h1>
          <p className="mt-2 text-gray-600">Ontdek onze selectie premium voertuigen</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 overflow-x-hidden">
        <div className="bg-white rounded-lg shadow-lg p-4 mb-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <h2 className="text-xl font-semibold text-gray-800">Filters</h2>
              <button
                onClick={() => setIsFilterVisible(!isFilterVisible)}
                className="text-gray-500 hover:text-gray-700"
              >
                {isFilterVisible ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                )}
              </button>
            </div>
            <button
              onClick={() => setFilters({
                merk: '',
                model: '',
                brandstof: [],
                transmissie: [],
                carrosserie: [],
                prijsMin: '',
                prijsMax: '',
                kmstandMin: '',
                kmstandMax: '',
                pkMin: '',
                pkMax: '',
                aantalDeurenMin: '',
                aantalDeurenMax: '',
                gewichtMin: '',
                gewichtMax: '',
                aantalZitplaatsenMin: '',
                aantalZitplaatsenMax: '',
                aantalCilindersMin: '',
                aantalCilindersMax: '',
                motorinhoudMin: '',
                motorinhoudMax: '',
                kleur: [],
                interieurkleur: [],
                bekledingsoort: [],
                aandrijving: [],
                bouwjaarMin: '',
                bouwjaarMax: '',
              })}
              className="text-red-600 hover:text-red-800 text-sm font-medium"
            >
              Reset Filters
            </button>
          </div>
          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${isFilterVisible
              ? 'max-h-[400px] md:max-h-[800px] opacity-100 mt-4 overflow-y-auto'
              : 'max-h-0 opacity-0'
              }`}
          >
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
              <div className="space-y-3">
                <div>
                  <label className="text-sm font-medium text-gray-700">Merk</label>
                  <select
                    name="merk"
                    value={filters.merk}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Alle merken</option>
                    {getMerkOptions().map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-700">Model</label>
                  <input
                    type="text"
                    name="model"
                    placeholder="Zoek op model"
                    className="w-full p-2 border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    onChange={handleFilterChange}
                    value={filters.model}
                  />
                </div>
              </div>
              <div className="space-y-3">
                <div>
                  <label className="text-sm font-medium text-gray-700">Brandstof</label>
                  <div className="grid grid-cols-2 gap-2">
                    {['Benzine', 'Diesel', 'Elektrisch', 'Hybride'].map(type => (
                      <label key={type} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={filters.brandstof.includes(type)}
                          onChange={() => handleCheckboxChange('brandstof', type)}
                          className="rounded border-gray-300 text-red-600 focus:ring-red-500"
                        />
                        <span className="text-sm text-gray-600">{type}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-700">Transmissie</label>
                  <div className="grid grid-cols-2 gap-2">
                    {['Automaat', 'Handgeschakeld'].map(type => (
                      <label key={type} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={filters.transmissie.includes(type)}
                          onChange={() => handleCheckboxChange('transmissie', type)}
                          className="rounded border-gray-300 text-red-600 focus:ring-red-500"
                        />
                        <span className="text-sm text-gray-600">{type}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                <div>
                  <label className="text-sm font-medium text-gray-700">Prijs Range (€)</label>
                  <div className="flex space-x-2">
                    <input
                      type="number"
                      name="prijsMin"
                      placeholder="Min"
                      className="w-1/2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.prijsMin}
                    />
                    <input
                      type="number"
                      name="prijsMax"
                      placeholder="Max"
                      className="w-1/2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.prijsMax}
                    />
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-700">Kilometerstand</label>
                  <div className="flex space-x-2">
                    <input
                      type="number"
                      name="kmstandMin"
                      placeholder="Min"
                      className="w-1/2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.kmstandMin}
                    />
                    <input
                      type="number"
                      name="kmstandMax"
                      placeholder="Max"
                      className="w-1/2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.kmstandMax}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                <label className="text-sm font-medium text-gray-700">Carrosserie</label>
                <div className="grid grid-cols-2 gap-2">
                  {['Hatchback', 'Sedan', 'Station', 'SUV', 'Coupe', 'Cabrio', 'MPV', 'Bestelbus'].map(type => (
                    <label key={type} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={filters.carrosserie.includes(type)}
                        onChange={() => handleCheckboxChange('carrosserie', type)}
                        className="rounded border-gray-300 text-red-600 focus:ring-red-500"
                      />
                      <span className="text-sm text-gray-600">{type}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="space-y-3">
                <div>
                  <label className="text-sm font-medium text-gray-700">Bouwjaar</label>
                  <div className="flex space-x-2">
                    <input
                      type="number"
                      name="bouwjaarMin"
                      placeholder="Van"
                      className="w-1/2 p-2 border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.bouwjaarMin}
                    />
                    <input
                      type="number"
                      name="bouwjaarMax"
                      placeholder="Tot"
                      className="w-1/2 p-2 border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.bouwjaarMax}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                <div>
                  <label className="text-sm font-medium text-gray-700">Vermogen (PK)</label>
                  <div className="flex space-x-2">
                    <input
                      type="number"
                      name="pkMin"
                      placeholder="Min"
                      className="w-1/2 p-2 border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.pkMin}
                    />
                    <input
                      type="number"
                      name="pkMax"
                      placeholder="Max"
                      className="w-1/2 p-2 border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.pkMax}
                    />
                  </div>
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">Gewicht (kg)</label>
                  <div className="flex space-x-2">
                    <input
                      type="number"
                      name="gewichtMin"
                      placeholder="Min"
                      className="w-1/2 p-2 border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.gewichtMin}
                    />
                    <input
                      type="number"
                      name="gewichtMax"
                      placeholder="Max"
                      className="w-1/2 p-2 border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      onChange={handleFilterChange}
                      value={filters.gewichtMax}
                    />
                  </div>
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">Kleur</label>
                  <div className="grid grid-cols-2 gap-2">
                    {getUniqueValues('kleur').map(kleur => (
                      <label key={kleur} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={filters.kleur.includes(kleur)}
                          onChange={() => handleCheckboxChange('kleur', kleur)}
                          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-600">{kleur}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">Interieur</label>
                  <div className="grid grid-cols-2 gap-2">
                    {getUniqueValues('interieurkleur').map(kleur => (
                      <label key={kleur} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={filters.interieurkleur.includes(kleur)}
                          onChange={() => handleCheckboxChange('interieurkleur', kleur)}
                          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-600">{kleur}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">Aandrijving</label>
                  <div className="grid grid-cols-2 gap-2">
                    {getUniqueValues('aandrijving').map(type => (
                      <label key={type} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={filters.aandrijving.includes(type)}
                          onChange={() => handleCheckboxChange('aandrijving', type)}
                          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-600">{type}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
          </div>
        ) : (
          <>
            <div className="mb-4 text-gray-600">
              {filteredCars.length} voertuigen gevonden
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredCars.map((car) => (
                <Link
                  to={`/product/${car.id}`}
                  key={car.id}
                  className="group focus:outline-none no-underline hover:no-underline"
                >
                  <div className={`bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1 h-96 flex flex-col ${car.verkocht ? 'relative' : ''}`}>
                    <div className="relative aspect-w-16 aspect-h-9 h-48">
                      <img
                        src={getCarImage(car)}
                        alt={`${car.merk} ${car.model}`}
                        className={`w-full h-full object-cover ${car.verkocht ? 'opacity-70' : ''}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = getDefaultImage();
                        }}
                      />
                      {car.verkocht && (
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="bg-red-600 text-white font-bold py-2 px-6 rounded-lg transform rotate-12 shadow-lg">
                            VERKOCHT
                          </div>
                        </div>
                      )}
                      <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-lg text-sm font-semibold">
                        € {car.prijs?.toLocaleString()}
                      </div>
                    </div>
                    <div className="p-4">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{car.merk} {car.model}</h3>
                      {!car.verkocht ? (
                        <>
                          <div className="grid grid-cols-2 gap-2 text-sm text-gray-600">
                            <div className="flex items-center">
                              <i className="fas fa-tachometer-alt mr-2"></i>
                              {car.kmstand?.toLocaleString()} km
                            </div>
                            <div className="flex items-center">
                              <i className="fas fa-gas-pump mr-2"></i>
                              {car.brandstof}
                            </div>
                            <div className="flex items-center">
                              <i className="fas fa-cog mr-2"></i>
                              {car.transmissie}
                            </div>
                            <div className="flex items-center">
                              <i className="fas fa-calendar mr-2"></i>
                              {new Date(car.datum).toLocaleDateString('en-GB')}
                            </div>
                          </div>
                          <div className="mt-4 flex justify-between items-center">
                            <span className="text-sm text-gray-500">{car.carrosserie}</span>
                            <span className="text-sm font-semibold text-blue-600 group-hover:text-red-800">
                              Bekijk details →
                            </span>
                          </div>
                        </>
                      ) : (
                        <div className="flex-1 flex flex-col justify-center mb-300">
                          <div className="text-center text-gray-600 italic mt-10">
                            Deze auto is niet meer beschikbaar
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Aanbod;